var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "audio-svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_1843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 112C2.68629 112 0 109.314 0 106V22C0 18.6863 2.68629 16 6 16H122C125.314 16 128 18.6863 128 22V106C128 109.314 125.314 112 122 112H6Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 22C0.8 19.1281 3.12812 16.8 6 16.8H122C124.872 16.8 127.2 19.1281 127.2 22V106C127.2 108.872 124.872 111.2 122 111.2H6C3.12812 111.2 0.8 108.872 0.8 106V22Z",
    stroke: "#EBECF0",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 112H122C125.314 112 128 109.314 128 106V102C128 105.314 125.314 108 122 108H6C2.68629 108 0 105.314 0 102V106C0 109.314 2.68629 112 6 112Z",
    fill: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 54H32.2C31.5373 54 31 54.5373 31 55.2V76.8C31 77.4628 31.5373 78 32.2 78H35.8C36.4627 78 37 77.4628 37 76.8V55.2C37 54.5373 36.4627 54 35.8 54Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8 46H42.2C41.5373 46 41 46.5373 41 47.2V84.8C41 85.4628 41.5373 86 42.2 86H45.8C46.4627 86 47 85.4628 47 84.8V47.2C47 46.5373 46.4627 46 45.8 46Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8 58H62.2C61.5373 58 61 58.5373 61 59.2V72.8001C61 73.4629 61.5373 74.0001 62.2 74.0001H65.8C66.4627 74.0001 67 73.4629 67 72.8001V59.2C67 58.5373 66.4627 58 65.8 58Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 52H52.2C51.5373 52 51 52.5373 51 53.2V78.8C51 79.4628 51.5373 80 52.2 80H55.8C56.4627 80 57 79.4628 57 78.8V53.2C57 52.5373 56.4627 52 55.8 52Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8 40H72.2C71.5373 40 71 40.5373 71 41.2V86.8C71 87.4627 71.5373 88 72.2 88H75.8C76.4627 88 77 87.4627 77 86.8V41.2C77 40.5373 76.4627 40 75.8 40Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8 50H82.2C81.5372 50 81 50.5373 81 51.2V80.8C81 81.4627 81.5372 82 82.2 82H85.8C86.4627 82 87 81.4627 87 80.8V51.2C87 50.5373 86.4627 50 85.8 50Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8 62H92.2C91.5373 62 91 62.5373 91 63.2V68.8C91 69.4627 91.5373 70 92.2 70H95.8C96.4627 70 97 69.4627 97 68.8V63.2C97 62.5373 96.4627 62 95.8 62Z",
    fill: "#7A869A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_1843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.7f78c36d6edb226190df9788152cea32.svg";
export { ForwardRef as ReactComponent };